// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3YPmB","content":"LoadingAlert_content__36gzw"};